import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePermissions } from '../context/PermissionsContext';

const DefaultRedirect = () => {
  const { hasPermission, hasModuleAccess, role, accessType } = usePermissions();

  // If Administrator or full access, go to dashboard
  if (role === 'Administrator' || accessType === 'subAdmin' || accessType === 'full') {
    return <Navigate to="/dashboard" replace />;
  }

  // Check for dashboard permission
  if (hasPermission('view_dashboard')) {
    return <Navigate to="/dashboard" replace />;
  }

  // Check for profile permission
  if (hasPermission('view_profile') || hasPermission('edit_profile')) {
    return <Navigate to="/profile" replace />;
  }

  // Check for various module access in priority order
  const redirectMap = [
    { module: 'Clients', path: '/clients' },
    { module: 'Transaction', path: '/account-ledger' },
    { module: 'IB Clients', path: '/ib-clients' },
    { module: 'KYC Documents', path: '/kyc-documents' },
    { module: 'Referral Tree', path: '/referral-tree' },
    { module: 'Trade Report', path: '/trade-report' },
    { module: 'PAMM', path: '/pamm-clients' },
    { module: 'Copy Trading', path: '/copy-trading-accounts' },
    { module: 'Payment Methods', path: '/payment-methods' },
    { module: 'Support', path: '/support-dashboard' },
    { module: 'Manage Staff', path: '/all-staff' },
    { module: 'Manage Roles', path: '/all-role' },
    { module: 'Manage Departments', path: '/all-department' },
    { module: 'Status & Types', path: '/account-type' },
    { module: 'App Settings', path: '/promo-slider' },
    { module: 'Mail Settings', path: '/email-design' },
    { module: 'Platform Settings', path: '/leverage-list' },
    { module: 'Log Activity', path: '/all-log-activity' },
  ];

  // Find first accessible module and redirect
  for (const { module, path } of redirectMap) {
    if (hasModuleAccess(module)) {
      return <Navigate to={path} replace />;
    }
  }

  // If no permissions at all, show access denied
  return (
    <div style={{ 
      padding: '40px', 
      textAlign: 'center',
      color: '#e74c3c',
      fontSize: '18px'
    }}>
      <h2>Access Denied</h2>
      <p>You don't have permission to access any pages.</p>
      <p>Please contact your administrator.</p>
    </div>
  );
};

export default DefaultRedirect;
